import React from "react";

const HomeFolderIcon = ({ size = 24, fill = "white" }) => (
  <svg width={size} height={size} viewBox='0 0 16 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      id='Vector'
      d='M7.50028 4.76741V6.28348H5.99135C5.91814 6.28348 5.85742 6.33884 5.85742 6.40848V7.15848C5.85742 7.22634 5.91814 7.28348 5.99135 7.28348H7.50028V8.79955C7.50028 8.8692 7.55742 8.92634 7.62528 8.92634H8.37528C8.44492 8.92634 8.50028 8.8692 8.50028 8.79955V7.28348H10.0092C10.0824 7.28348 10.1431 7.22634 10.1431 7.15848V6.40848C10.1431 6.33884 10.0824 6.28348 10.0092 6.28348H8.50028V4.76741C8.50028 4.69777 8.44492 4.64063 8.37528 4.64063H7.62528C7.55742 4.64063 7.50028 4.69777 7.50028 4.76741ZM14.5717 2.18348H8.16099L6.06635 0.179911C6.0397 0.15496 6.00464 0.140938 5.96814 0.140625H1.42885C1.11278 0.140625 0.857422 0.395982 0.857422 0.712054V11.2835C0.857422 11.5996 1.11278 11.8549 1.42885 11.8549H14.5717C14.8878 11.8549 15.1431 11.5996 15.1431 11.2835V2.75491C15.1431 2.43884 14.8878 2.18348 14.5717 2.18348ZM13.8574 10.5692H2.14314V1.42634H5.50921L7.64492 3.4692H13.8574V10.5692Z'
      fill={fill}
    />
  </svg>
);

export default HomeFolderIcon;
